// PermissionError.tsx

import React from 'react';
import styles from "./PermissionError.module.css";

interface PermissionErrorProps {
}

export const PermissionError: React.FC<PermissionErrorProps> = () => {
  return (
    <div className={styles.overlay}>
      <div className={styles.window}>
        <div className={styles.windowContent}>
          <p>本サービスを使用する権限がありません。管理者にお問い合わせください。</p>
        </div>
      </div>
    </div>
  );
};
